import { useState, useEffect, useCallback } from "react";
import { getGearAvailability, createGear, updateGear, deleteGear } from "@/lib/api";
import { toast } from "sonner";

export function useInventoryData(dateStart, dateEnd) {
  const [gear, setGear] = useState([]);
  const [loading, setLoading] = useState(true);
  const hasDateRange = dateStart && dateEnd;

  const fetchGear = useCallback(async () => {
    try {
      const res = hasDateRange
        ? await getGearAvailability(dateStart, dateEnd)
        : await getGearAvailability();
      setGear(res.data);
    } catch {
      toast.error("Failed to load inventory");
    } finally {
      setLoading(false);
    }
  }, [dateStart, dateEnd, hasDateRange]);

  useEffect(() => { fetchGear(); }, [fetchGear]);

  const handleCreate = async (form) => {
    await createGear(form);
    toast.success("Gear added");
    fetchGear();
  };

  const handleUpdate = async (gearId, form) => {
    await updateGear(gearId, form);
    toast.success("Gear updated");
    fetchGear();
  };

  const handleDelete = async (gearId) => {
    await deleteGear(gearId);
    toast.success("Gear deleted");
    fetchGear();
  };

  return { gear, loading, fetchGear, handleCreate, handleUpdate, handleDelete };
}
